/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Paper,
  Grid,
  Button,
  MenuItem,
  Card,
  Typography,
  Box,
  IconButton,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import MyTextField from '../../../components/MyTextField';
import MySelect from '../../../components/MySelect';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store';
import { getEmployeeLoanCurrencies, getEmployeeLoanPeriod, getEmployeeLoanTypes, setEmployeeLoan, setEmployeeLoanHasNote } from '../../../api/signalApi';
import { getDatestring } from '../../../utils/date';
import MyDatepicker from '../../../components/my-datepicker';
import dayjs, { Dayjs } from 'dayjs';
import MySnackbar from '../../../components/MySnackbar';
import { LoanPeriod, setLoanRequestResult } from '../../../store/slices/documents';
import { addCharactersToString } from '../../../utils/tools';
import ListFilesToUpload from '../../../components/ListFilesToUpload';
import { uploadFilesToFilestorage } from '../../../utils/media-files';
import { addOrUpdateGroupId } from '../../../api/fileStorage';
import MySelectAssignedCompany from '../../../components/MySelectAssignedCompany';

interface AmortizationItem {
  id: number;
  period: LoanPeriod;
  // schedule: string;
  requestedAmount: string;
  scheduledAmortization: string;
  doubleAmortization: string;
  isEditing?: boolean;
  tempAmount?: string;
}

let dynamicRequestedAmount: number = 0;

const FormRequest = (
  // {setRefreshTime}:{setRefreshTime: (value: Date) => void}
  {forceRefresh, refreshKey}: {forceRefresh: () => void, refreshKey: number}
) => {
  const dispatch = useDispatch<AppDispatch>();
  const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
  const {loans} = useSelector((state: RootState) => state.documents);
  const [loading, setLoading] = useState(false);
  // const [loanNumber, setLoanNumber] = useState('00000001');
  const [currency, setCurrency] = useState('');
  const [type, setType] = useState('');
  const [requestedAmount, setRequestedAmount] = useState('0');
  const [date, setDate] = useState<Dayjs | undefined>(dayjs().locale('pe'));
  const [periodStart, setPeriodStart] = useState<string>('');
  const [installmentType, setInstallmentType] = useState('0');
  const [installmentDouble, setInstallmentDouble] = useState(false);
  const [numberOfInstallments, setNumberOfInstallments] = useState('1');
  const [installmentAmount, setInstallmentAmount] = useState('0');
  const [errorMsg, setErrorMsg] = useState('');
  const [amortizationSchedule, setAmortizationSchedule] = useState<AmortizationItem[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [rucSelected, setRucSelected] = useState<string>("");
  

  useEffect(() => {
    if (!loans?.requestResult?.id || selectedFiles.length === 0 || loading) {
      return
    }
    uploadFiles(loans.requestResult.id);
  }, [loans?.requestResult]);
  
  useEffect(() => {
    if (!companyselected || !connectionId || loading) {
        return;
    }
    setLoading(true);
    const getInitialData = async () => {
      setLoading(true);
      try {
        await Promise.all([
          getEmployeeLoanTypes(),
          getEmployeeLoanCurrencies(),
        ]);
      } finally {
        setLoading(false);
      }
    };
    getInitialData();
  }, [companyselected, connectionId])

  useEffect(() => {
    if (!loans.currencies?.length) {
      return;
    }
    if (!currency) {
      setCurrency(loans.currencies[0].CodMoneda);
    }
  }, [loans.currencies])

  useEffect(() => {
    if (companyselected && connectionId && date) {
      getEmployeeLoanPeriod(getDatestring(date?.toISOString(), '-', false) );
    }
  }, [date, companyselected, connectionId])
  
  useEffect(() => {
    if (loans.periods?.length) {
      setPeriodStart(loans.periods[0].NroProyectoEsquemaPeriodo);
    }
  }, [loans.periods])

  useEffect(() => {
    calculateAmortization();
  }, [requestedAmount, installmentType, numberOfInstallments, installmentAmount, date, periodStart]);
  
  const uploadFiles = async (loanId: string) => {
    if(!selectedFiles.length) {
      // setRefreshTime(new Date());
      forceRefresh();
      return;
    }
    console.log('subiendo archivos...')
    setLoading(true);
    const Uploadresult = await uploadFilesToFilestorage(selectedFiles, setErrorMsg, false, loanId);
    if (Uploadresult) {
      setSelectedFiles([])
      const updateGroupId = await addOrUpdateGroupId(Uploadresult.filestorageData);
      if (updateGroupId?.Type !== 0) {
          setErrorMsg(updateGroupId?.Message || "Error registrando la información en s10.");
          setLoading(false);
          // setRefreshTime(new Date());
          forceRefresh();
          return;
      }
      await setEmployeeLoanHasNote(loanId, 1);
    }
    if (!Uploadresult ) {
      setErrorMsg(
        'Ocurrió un error al subir el sustento.'
      )
    }
    setLoading(false);
    // setRefreshTime(new Date());
    forceRefresh()
  }

  const calculateAmortization = () => {
    if (installmentType === '1' || !date || !periodStart || loans.periods.length === 0) {
      return;
    }
    const amount = parseFloat(requestedAmount) || 0;
    const installments = parseInt(numberOfInstallments) || 1;
    const installmentAmt = parseFloat(installmentAmount) || 0;
    const selectedPeriod = loans.periods.find(p => p.NroProyectoEsquemaPeriodo === periodStart);
    if (!selectedPeriod) {
      return
    }

    const filteredPeriods = loans.periods.filter(p => new Date(p.Del) >= new Date(selectedPeriod.Del));
    
    let schedule: AmortizationItem[] = [];

    if (installmentType === '0') {
      const installmentValue = amount / installments;
      for (let i = 0; i < installments; i++) {
        const installmentAmount = i === installments - 1 ? (amount - (installmentValue * i)).toFixed(2) : installmentValue.toFixed(2);
        
        schedule.push({
          id: i + 1,
          period: filteredPeriods[i],
          // schedule: `${(month + 1) < 10 ? '0' : ''}${month + 1}${year} ${currentInstallment.toFixed(2)} 0.00`,
          requestedAmount: installmentAmount,
          scheduledAmortization: installmentAmount,
          doubleAmortization: '0.00',
          isEditing: false
        });
      }
    } else if (installmentType === '2') {
      if (installmentAmt <= 0) return;
      
      const installmentsNeeded = Math.ceil(amount / installmentAmt);
      let remaining = amount;
      
      for (let i = 0; i < installmentsNeeded; i++) {        
        const currentInstallment = i === installmentsNeeded - 1 ? remaining : Math.min(installmentAmt, remaining);

        schedule.push({
          id: i + 1,
          period: filteredPeriods[i],
          // schedule: `${(month + 1) < 10 ? '0' : ''}${month + 1}${year} ${currentInstallment.toFixed(2)} 0.00`,
          requestedAmount: currentInstallment.toFixed(2),
          scheduledAmortization: currentInstallment.toFixed(2),
          doubleAmortization: '0.00',
          isEditing: false
        });
        
        remaining -= currentInstallment;
        if (remaining <= 0) break;
      }
    }
    
    setAmortizationSchedule(schedule);
  };

  const handleAddManualInstallment = () => {
    const amount = parseFloat(requestedAmount) || 0;
    const currentTotal = amortizationSchedule.reduce((sum, item) => sum + parseFloat(item.scheduledAmortization || '0'), 0);
    const remaining = amount - currentTotal;
    
    if (remaining <= 0) return;
    if (!date) {
      return;
    }
    
    const nextId = amortizationSchedule.length > 0 ? Math.max(...amortizationSchedule.map(item => item.id)) + 1 : 1;
    const dateParts = date?.toDate().toISOString().split('-');
    const startDate = new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
    const currentDate = new Date(startDate);
    currentDate.setMonth(currentDate.getMonth() + nextId);
    
    const newInstallment = {
      id: nextId,
      period: loans.periods[nextId - 1],
      // schedule: ``,
      requestedAmount: '0.00',
      scheduledAmortization: '0.00',
      doubleAmortization: '0.00',
      isEditing: true,
      tempAmount: ''
    };
    
    setAmortizationSchedule([...amortizationSchedule, newInstallment]);
  };

  const handleRemoveInstallment = (id: number) => {
    setAmortizationSchedule(amortizationSchedule.filter(item => item.id !== id));
  };

  const handleStartEditing = (id: number) => {
    setAmortizationSchedule(amortizationSchedule.map(item => {
      if (item.id === id) {
        return {
          ...item,
          isEditing: true,
          tempAmount: item.scheduledAmortization
        };
      }
      return item;
    }));
  };

  const handleTempAmountChange = (id: number, value: string) => {
    setAmortizationSchedule(amortizationSchedule.map(item => {
      if (item.id === id) {
        return {
          ...item,
          tempAmount: value
        };
      }
      return item;
    }));
  };


  const handleTempPeriodChange = (id: number, value: string) => {
    setAmortizationSchedule(amortizationSchedule.map(item => {
      if (item.id === id) {
        return {
          ...item,
          period: loans.periods.find(period => period.NroProyectoEsquemaPeriodo === value) as any,
        };
      }
      return item;
    }));
  };

  const handleConfirmAmount = (id: number) => {
    const amount = parseFloat(requestedAmount) || 0;
    const currentTotal = amortizationSchedule.reduce((sum, item) => 
      item.id === id ? sum : sum + parseFloat(item.scheduledAmortization || '0'), 0);
    
    const item = amortizationSchedule.find(item => item.id === id);
    if (!item) return;
    
    const newValue = parseFloat(item.tempAmount || '0') || 0;
    const remaining = amount - currentTotal;
    
    const maxAllowed = remaining + parseFloat(item.scheduledAmortization || '0');
    const validatedValue = Math.min(newValue, maxAllowed);
    
    setAmortizationSchedule(amortizationSchedule.map(item => {
      if (item.id === id) {
        return {
          ...item,
          scheduledAmortization: validatedValue.toFixed(2),
          requestedAmount: validatedValue.toFixed(2),
          isEditing: false,
          tempAmount: undefined
        };
      }
      return item;
    }));
  };

  const handleCancelEditing = (id: number) => {
    setAmortizationSchedule(amortizationSchedule.map(item => {
      if (item.id === id) {
        return {
          ...item,
          isEditing: false,
          tempAmount: undefined
        };
      }
      return item;
    }));
  };

  const handleSubmit = async () => {
    const totalAmortization = amortizationSchedule.reduce((sum, item) => sum + parseFloat(item.scheduledAmortization || '0'), 0);
    const requested = parseFloat(requestedAmount) || 0;
    
    if (Math.abs(totalAmortization - requested) > 0.01) {
      setErrorMsg(`El total de las amortizaciones (${totalAmortization.toFixed(2)}) no coincide con el monto solicitado (${requested.toFixed(2)})`);
      return;
    }
    
    if (!date) {
      setErrorMsg('Debe seleccionar una fecha.');
      return;
    }
    let nroProyectoEsquemaPeriodo: string | undefined = '';
    if (installmentType !== '1') {
      nroProyectoEsquemaPeriodo = loans.periods.find(p => p.NroProyectoEsquemaPeriodo === periodStart)?.NroProyectoEsquemaPeriodo || '';
    }
    await setEmployeeLoan(
      rucSelected,
      type, 
      installmentType, 
      numberOfInstallments, 
      requestedAmount, 
      currency, 
      installmentAmount, 
      installmentType === '1' || !installmentDouble ? 0 : 1, 
      amortizationSchedule.map(
        ({period, scheduledAmortization}) => `${period.NroProyectoEsquemaPeriodo}${addCharactersToString(scheduledAmortization, 15)}${addCharactersToString('0.00', 15)}`
      ).join('|'),
      nroProyectoEsquemaPeriodo,
      getDatestring(date.toDate(), '-', false),
    );
    setLoading(false);
  };

  const getRemainingAmount = () => {
    const amount = parseFloat(requestedAmount) || 0;
    const currentTotal = amortizationSchedule.reduce((sum, item) => sum + parseFloat(item.scheduledAmortization || '0'), 0);
    return amount - currentTotal;
  };

  const isSubmitDisabled = () => {
    if (amortizationSchedule.length === 0) return true;
    if (!type || !date || !currency || !Number(requestedAmount)) return true;
    
    const totalAmortization = amortizationSchedule.reduce((sum, item) => sum + parseFloat(item.scheduledAmortization || '0'), 0);
    const requested = parseFloat(requestedAmount) || 0;
    
    return Math.abs(totalAmortization - requested) > 0.01;
  };

  return (
    <Paper
      elevation={3}
      style={{
        width: "100%", 
        borderRadius: "0.5rem",
        minHeight: "10rem",
        padding: "1.5rem",
        marginTop: "0.9rem",
      }}
    >
      <Grid item xs={12} pb="1rem">
          <MySelectAssignedCompany
              setRucSelected={(value) => {
                  setRucSelected(value);
              }} 
              rucSelected={rucSelected}
              minWidth='100%'
          />
      </Grid>
      <Grid container spacing={2} style={{ marginBottom: '1rem' }}>
        {/* <Grid item xs={12} sm={12} xl={6}>
          <MyTextField
            label="Préstamo N°"
            value={loanNumber}
            onChange={(e) => setLoanNumber(e.target.value)}
            margin="normal"
            style={{width: "100%"}} 
          />
        </Grid> */}
        <Grid item xs={12} sm={12} xl={6}>
          <MySelect
            label={'Moneda'}
            value={currency}
            onChange={(e) => setCurrency(e.target.value as string)}
            displayEmpty
          >
            {loans.currencies?.map((item: any) => (
              <MenuItem key={item.CodMoneda} value={item.CodMoneda}>
                {item.Descripcion}
              </MenuItem>
            ))}
          </MySelect>
        </Grid>
        <Grid item xs={12} sm={12} xl={6}>
          <MySelect
            label={'Tipo'}
            value={type}
            onChange={(e) => setType(e.target.value as string)}
            displayEmpty
          >
            {loans.types?.map((item: any) => (
              <MenuItem key={item.NroTipoPrestamo} value={item.NroTipoPrestamo}>
                {item.Descripcion}
              </MenuItem>
            ))}
          </MySelect>
        </Grid>
        <Grid item xs={12} sm={12} xl={6}>
          <MyTextField
            label="Monto Solicitado"
            value={requestedAmount}
            onChange={(e) => {
              setRequestedAmount(e.target.value);
            }}
            margin="normal"
            style={{width: "100%"}} 
            type="number"
          />
        </Grid>
        <Grid item xs={12} sm={12} xl={6}>
          <MyDatepicker
            labelText="Fecha"
            value={date}
            // minDate={dayjs()}
            setSelectedDate={(value: Dayjs | null) => {
              setDate(value?.endOf('day'));
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12} xl={6}>
          <MySelect
            label={'Tipo de cuota'}
            value={installmentType}
            onChange={(e) => {
              setInstallmentType(e.target.value as string);
              setAmortizationSchedule([]);
            }}
            displayEmpty
          >
            <MenuItem value="0">Automático (por número de cuotas)</MenuItem>
            <MenuItem value="1">Manual</MenuItem>
            <MenuItem value="2">Automático (por monto de cuotas)</MenuItem>
          </MySelect>
        </Grid>
        {installmentType !== '1' && !!loans.periods?.length && (
          <Grid item xs={12} sm={12} xl={6}>
            
            <MySelect
              label={'Período Inicial'}
              value={periodStart}
              onChange={(e) => setPeriodStart(e.target.value)}
              fullWidth
              displayEmpty
            >
              {loans.periods?.map((item: any) => (
                <MenuItem key={item.NroProyectoEsquemaPeriodo} value={item.NroProyectoEsquemaPeriodo}>
                  {item.Descripcion}
                </MenuItem>
              ))}
            </MySelect>
          </Grid>
        )}
        
        {installmentType !== '1' && (
          <Grid item xs={12} sm={12} xl={6} >
            <FormControlLabel
                value="start"
                control={<Checkbox
                    checked={installmentDouble}
                    onChange={() => setInstallmentDouble(!installmentDouble)}
                />}
                label="Cuota doble"
                style={{marginTop: '1rem'}}
            />
          </Grid>
        )}
        {installmentType === '0' && (
          <Grid item xs={12} sm={12} xl={6}>
            <MyTextField
              label="Número de cuotas"
              value={numberOfInstallments}
              onChange={(e) => {
                setNumberOfInstallments(e.target.value)
              }}
              style={{width: "100%"}} 
              type="number"
            />
          </Grid>
        )}
        
        {installmentType === '2' && (
          <Grid item xs={12} sm={12} xl={6}>
            <MyTextField
              label="Monto de cada cuota"
              value={installmentAmount}
              onChange={(e) => {
                setInstallmentAmount(e.target.value)}
              }
              style={{width: "100%"}} 
              type="number"
            />
          </Grid>
        )}
        <Grid item width={"100%"} marginTop="1rem">
            <ListFilesToUpload
                setSelectedFiles={setSelectedFiles} 
                selectedFiles={selectedFiles}
                buttonLabel={`Agregar sustento (Opcional)`}
                filesLimit={2}
            />
        </Grid>
        
      </Grid>

      <Typography variant="subtitle1" gutterBottom style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>
        Cronograma de amortizaciones
      </Typography>

      {installmentType === '1' && (
        <Box display="flex" justifyContent="flex-end" mb={2}>
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleAddManualInstallment}
            disabled={getRemainingAmount() <= 0}
          >
            Agregar Cuota (Restante: {getRemainingAmount().toFixed(2)})
          </Button>
        </Box>
      )}

      <Grid container spacing={2}>
        {Number(requestedAmount) > 0 && amortizationSchedule.map((item, i) => {
          if (i === 0) {
            dynamicRequestedAmount = Number(requestedAmount);
          }
          dynamicRequestedAmount -= Number(item.scheduledAmortization);
          return (
            <Grid item xs={12} key={item.id}>
              <Card 
                sx={{ p: 2, position: 'relative' }} 
                elevation={4}
              >
                {installmentType === '1' && (
                  <>
                    <IconButton 
                      onClick={() => handleRemoveInstallment(item.id)}
                      sx={{ position: 'absolute', top: 8, right: 8 }}
                    >
                      <DeleteIcon />
                    </IconButton>
                    
                    {!item.isEditing && (
                      <IconButton 
                        onClick={() => handleStartEditing(item.id)}
                        sx={{ position: 'absolute', top: 8, right: 48 }}
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                  </>
                )}
                
                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  <strong>Cuota {item.id}:</strong> {item?.period?.Descripcion}
                </Typography>
                
                
                  {installmentType === '1' && item.isEditing ? (
                  <>
                  <MySelect
                    label={'Período'}
                    value={item.period?.NroProyectoEsquemaPeriodo || ''}
                    onChange={(e) => handleTempPeriodChange(item.id, e.target.value)}
                    fullWidth
                    displayEmpty
                  >
                    {loans.periods?.filter(period => {
                      // Si no estamos editando, usar la lógica original
                      if (!item.isEditing) {
                        return amortizationSchedule.map(a => a.period?.NroProyectoEsquemaPeriodo)
                          .includes(period.NroProyectoEsquemaPeriodo) === false;
                      }

                      // Obtener el item anterior y siguiente
                      const currentIndex = amortizationSchedule.findIndex(a => a.id === item.id);
                      const prevItem = amortizationSchedule[currentIndex - 1];
                      const nextItem = amortizationSchedule[currentIndex + 1];

                      // Convertir fechas a objetos Date para comparación
                      const periodDate = new Date(period.Del);
                      const prevDate = prevItem?.period?.Del ? new Date(prevItem.period.Del) : null;
                      const nextDate = nextItem?.period?.Del ? new Date(nextItem.period.Del) : null;

                      // Verificar que el período no esté ya en uso (excepto el actual)
                      const isPeriodUsed = amortizationSchedule
                        .filter(a => a.id !== item.id)
                        .some(a => a.period?.NroProyectoEsquemaPeriodo === period.NroProyectoEsquemaPeriodo);

                      // Filtro: debe ser mayor que el anterior, menor que el siguiente y no estar usado
                      return (
                        (!prevDate || periodDate > prevDate) &&
                        (!nextDate || periodDate < nextDate) &&
                        !isPeriodUsed
                      );
                    }).map((period: LoanPeriod) => (
                      <MenuItem key={period.NroProyectoEsquemaPeriodo} value={period.NroProyectoEsquemaPeriodo}>
                        {period.Descripcion}
                      </MenuItem>
                    ))}
                  </MySelect>

                  
                  <MyTextField
                    label="Monto de la cuota"
                    value={item.tempAmount || ''}
                    onChange={(e) => handleTempAmountChange(item.id, e.target.value)}
                    type="number"
                    style={{width: "100%"}}
                    fullWidth
                    // autoFocus
                    inputProps={{
                      min: 0,
                      step: "0.01"
                    }}
                  />
                  <Typography variant="caption" color="textSecondary">
                    Máximo permitido: {(getRemainingAmount() + parseFloat(item.scheduledAmortization || '0')).toFixed(2)}
                  </Typography>
                  </>
                  ) : (
                    <>
                      <Box sx={{ display: 'flex' }}>
                        <Typography variant="body2" mr={'.5rem'}>
                          <strong>Monto Programado:</strong>
                        </Typography>
                        <Typography variant="body2">{item.scheduledAmortization}</Typography>
                      </Box>
                      
                      <Box sx={{ display: 'flex' }}>
                        <Typography variant="body2" mr={'.5rem'}>
                          <strong>Saldo:</strong>
                        </Typography>
                        <Typography variant="body2">{dynamicRequestedAmount}</Typography>
                      </Box>
                    </>
                  )}
                  {installmentType === '1' && item.isEditing && (
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <Box display="flex" gap={1}>
                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<DoneIcon />}
                            onClick={() => handleConfirmAmount(item.id)}
                            disabled={!item.tempAmount || isNaN(parseFloat(item.tempAmount)) || parseFloat(item.tempAmount) <= 0}
                          >
                            Confirmar
                          </Button>
                          <Button
                            variant="outlined"
                            onClick={() => handleCancelEditing(item.id)}
                          >
                            Cancelar
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
              </Card>
            </Grid>);
        })}
      </Grid>

      {amortizationSchedule.length > 0 && (
        <Box mt={2} textAlign="right">
          <Typography variant="body1">
            <strong>Monto solicitado:</strong> {requestedAmount}
          </Typography>
          <Typography variant="body1">
            <strong>Total Programado:</strong> {amortizationSchedule.reduce((sum, item) => sum + parseFloat(item.scheduledAmortization || '0'), 0).toFixed(2)}
          </Typography>
          <Typography variant="body1" color={Math.abs(amortizationSchedule.reduce((sum, item) => sum + parseFloat(item.scheduledAmortization || '0'), 0) - (parseFloat(requestedAmount) || 0)) > 0.01 ? 'error' : 'inherit'}>
            <strong>Saldo:</strong> {(amortizationSchedule.reduce((sum, item) => sum + parseFloat(item.scheduledAmortization || '0'), 0) - (parseFloat(requestedAmount) || 0)).toFixed(2)}
          </Typography>
        </Box>
      )}

      <Grid container justifyContent="flex-end" style={{ marginTop: '1.5rem' }}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            startIcon={<CheckIcon />}
            onClick={handleSubmit}
            style={{
              width: "100%",
              height: "2.5rem",
              display: "inline-flex",
              padding: "0.625rem 1.5rem",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.5rem",
            }}
            disabled={isSubmitDisabled() || loading}
          >
            Solicitar
          </Button>
        </Grid>
      </Grid>
      <MySnackbar
        open={errorMsg !== ""}
        msg={errorMsg}
        severity="error"
        onClose={() => {
          setErrorMsg("");
        }}
      />
      {loans.requestResult.success !== null && loans.requestResult.msg && <MySnackbar
        open={true}
        msg={loans.requestResult.msg}
        severity={loans.requestResult.success ? "success": "error"}
        onClose={() => {
          dispatch(setLoanRequestResult({success: null, msg: null}))
          setRequestedAmount('0');
          setInstallmentDouble(false);
          setNumberOfInstallments('1');
        }}
      />}
    </Paper>
  );
};

export default FormRequest;